import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { FaHome, FaUser } from "react-icons/fa";
import axios from "axios";
import cogoToast from "cogo-toast";

// Safe Event ID Generator — crypto.randomUUID() not available on older browsers/HTTP
const generateEventId = () => {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return "lead_" + Date.now() + "_" + Math.random().toString(36).substring(2, 9);
};

const GlobalContactPopup = () => {
  const [show, setShow] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Optionally hide it if a user navigates away before closing
    setShow(false);

    const timer = setTimeout(() => {
      setShow(true);
    }, 5000);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  // Form State
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile_no, setMobile_no] = useState("");
  const [address, setAddress] = useState("");
  const [subject, setSubject] = useState("Query");
  // const [message, setMessage] = useState("");

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const validateForm = () => {
    let formErrors = {};
    if (!name) formErrors.name = "Name is required";
    if (email && !/\S+@\S+\.\S+/.test(email)) {
      formErrors.email = "Email is invalid";
    }
    if (!mobile_no) {
      formErrors.mobile_no = "Mobile number is required";
    } else if (!/^\d{10}$/.test(mobile_no)) {
      formErrors.mobile_no = "Mobile number is invalid";
    }

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true);

      // STEP 1: API Request se pehle Event ID generate karein
      const eventId = generateEventId();

      try {
        // STEP 2: API Request me event_id pass karein
        const response = await axios.post(`https://ayushiconstruction.com/api/contact`, {
          name,
          email: email || "na",
          mobile_no,
          subject,
          address: address || "na",
          message: "na",
          event_id: eventId,
        });

        // STEP 3: Sirf Success Response par dataLayer push karein (Meta CAPI deduplication via GTM)
        if (response.data.success === true) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "generate_lead",
            event_id: eventId,
            first_name: name,
            email: email,
            phone_number: mobile_no,
          });

          cogoToast.success(`${response.data.message}`);
          setName("");
          setEmail("");
          setMobile_no("");
          setAddress("");
          setLoading(false);
          handleClose(); // Close modal on success
        } else {
          setLoading(false);
          cogoToast.error(response.data.message || "Failed to submit form");
          console.error("Error submitting form");
        }
      } catch (error) {
        setLoading(false);
        const errorMsg = (error && error.response && error.response.data && error.response.data.message) || "An error occurred";
        cogoToast.error(errorMsg);
        console.error("Error submitting form", error);
      }
    }
  };

  return (
    <>
      <FloatingContainer onClick={ handleShow }>
        <div className="fab-icon-container">
          <FaUser className="fab-icon" />
        </div>

      </FloatingContainer>

      {/* Bootstrap Modal */ }
      <Modal show={ show } onHide={ handleClose } centered>
        <Modal.Header closeButton style={ { backgroundColor: "#f26a20", color: "white" } }>
          <Modal.Title>Request a Callback</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center mb-4">
            <FaHome size={ 38 } style={ { color: "#f26a20" } } />
            <h5 className="mt-2 mb-1" style={ { fontWeight: "bold", color: "#34495e" } }>
              Looking for Your Dream Home?
            </h5>
            <p className="text-muted mb-0" style={ { fontSize: "14px" } }>
              Share your details below and our property expert will call you back shortly.
            </p>
          </div>

          <form onSubmit={ handleSubmit } className="p-2">
            <div className="mb-3">
              <label className="form-label">Name <span className="text-danger">*</span></label>
              <input
                type="text"
                className={ `form-control ${errors.name ? "is-invalid" : ""}` }
                placeholder="Enter your name"
                value={ name }
                onChange={ (e) => {
                  setName(e.target.value);
                  setErrors({ ...errors, name: "" });
                } }
              />
              { errors.name && <div className="invalid-feedback">{ errors.name }</div> }
            </div>

            <div className="mb-3">
              <label className="form-label">Email</label>
              <input
                type="email"
                className={ `form-control ${errors.email ? "is-invalid" : ""}` }
                placeholder="Enter your email"
                value={ email }
                onChange={ (e) => {
                  setEmail(e.target.value);
                  setErrors({ ...errors, email: "" });
                } }
              />
              { errors.email && <div className="invalid-feedback">{ errors.email }</div> }
            </div>

            <div className="mb-3">
              <label className="form-label">Mobile Number <span className="text-danger">*</span></label>
              <input
                type="text"
                className={ `form-control ${errors.mobile_no ? "is-invalid" : ""}` }
                placeholder="Enter 10-digit mobile number"
                maxLength={ 10 }
                value={ mobile_no }
                onChange={ (e) => {
                  setMobile_no(e.target.value.replace(/\D/g, ""));
                  setErrors({ ...errors, mobile_no: "" });
                } }
              />
              { errors.mobile_no && <div className="invalid-feedback">{ errors.mobile_no }</div> }
            </div>

            <div className="mb-3">
              <label className="form-label">Address (optional)</label>
              <input
                type="text"
                className={ `form-control ${errors.address ? "is-invalid" : ""}` }
                placeholder="Enter your address"
                value={ address }
                onChange={ (e) => {
                  setAddress(e.target.value);
                  setErrors({ ...errors, address: "" });
                } }
              />
              { errors.address && <div className="invalid-feedback">{ errors.address }</div> }
            </div>

            {/* <div className="mb-3">
              <label className="form-label">Message</label>
              <textarea
                className={ `form-control ${errors.message ? "is-invalid" : ""}` }
                rows="3"
                placeholder="How can we help you?"
                value={ message }
                onChange={ (e) => {
                  setMessage(e.target.value);
                  setErrors({ ...errors, message: "" });
                } }
              ></textarea>
              { errors.message && <div className="invalid-feedback">{ errors.message }</div> }
            </div> */}

            <div className="d-grid mt-4">
              <button
                type="submit"
                className="btn text-white py-2"
                style={ { backgroundColor: "#34495e", fontWeight: "bold" } }
                disabled={ loading }
              >
                { loading ? "Submitting..." : "Submit Request" }
              </button>
            </div>
          </form>

          <p className="text-center text-muted mt-3 mb-0" style={ { fontSize: "13px" } }>
            Prefer to talk directly? Call us at{ " " }
            <a href="tel:9981268611" style={ { color: "#34495e", fontWeight: "bold" } }>
              9981268611
            </a>
          </p>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default GlobalContactPopup;

// Styled Components for Floating Button
const FloatingContainer = styled.div`
  position: fixed;
  bottom: 165px;
  right: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  z-index: 1000;
  transition: transform 0.3s ease-in-out;

  &:hover {
    transform: scale(1.1);
  }

  .fab-icon-container {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: #f26a20;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 6px rgba(0,0,0,0.2);
  }

  .fab-icon {
    font-size: 24px;
    color: white;
  }

  .fab-text {
    font-size: 13px;
    font-weight: 700;
    color: #003366;
    text-shadow: 0px 0px 2px rgba(255,255,255,0.8);
  }
`;
